/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
jQuery(document).ready(function($) {
	// We are using sidr to handle our menu JS
	// https://www.berriart.com/sidr/
	var sidrName = "sidr";

	$('.mobile-navigation .main-menu').sidr({
		name: sidrName,
		side: "right",
		source: ".main-navigation",
		renaming: false,
		onOpen: function() {
			$('.main-menu #mobile-menu-toggle').addClass('menu-open');
			$('html').css('overflow', 'hidden');
			$('#page').prepend("<div class='menu-close'><div><span></span><span></span></div></div>")
			$('#page').on("click.sidr", function(e) {
				$.sidr("close", sidrName);
			});
			if ($('#wpadminbar').length) {
				$('.sidr').addClass('has-admin-bar');
				$('.menu-close').addClass('has-admin-bar');
			}
		},
		onClose: function() {
			$(window).off("click.sidr");
			$('.main-menu #mobile-menu-toggle').removeClass('menu-open');
			$('html').css('overflow', 'visible');
			$('.menu-close').remove();
		}
	});
	// Don't you dare close me out!
	$('#' + sidrName).on("click.sidr", function(e) {
		e.stopPropagation();
	});
});
